/**
 * NiV → הודעות — control plane for the messaging router
 * (whatsapp_integration.md §4.1): channel policy, inbound inbox, outbox log,
 * Meta templates, usage. Sub-section lives in the URL (/dashboard/niv/messages/:sub).
 * Error codes: CK-10500–10515 (panels).
 */
import { ChatsCircle, Sliders, Tray, PaperPlaneTilt, FileText, ChartBar } from "@phosphor-icons/react";
import { useGetNivInboxQuery } from "../../../../store/services/nivApi";
import PolicyPanel from "./PolicyPanel";
import InboxPanel from "./InboxPanel";
import OutboxPanel from "./OutboxPanel";
import TemplatesPanel from "./TemplatesPanel";
import UsagePanel from "./UsagePanel";
import "./NivMessagesTab.css";

export const MESSAGES_SECTIONS = [
  { id: "policy", label: "מדיניות ערוצים", icon: Sliders },
  { id: "inbox", label: "תיבת נכנס", icon: Tray },
  { id: "outbox", label: "יומן שליחות", icon: PaperPlaneTilt },
  { id: "templates", label: "תבניות", icon: FileText },
  { id: "usage", label: "שימוש", icon: ChartBar },
];
export const MESSAGES_SECTION_IDS = new Set(MESSAGES_SECTIONS.map((s) => s.id));
export const DEFAULT_MESSAGES_SECTION = "policy";
/** Shared query args so the tab badge and the inbox panel hit one cache entry. */
export const INBOX_QUERY_ARGS = { unreadOnly: false, limit: 100 };

function NivMessagesTab({ isAuthorized, section, onSectionChange }) {
  const active = MESSAGES_SECTION_IDS.has(section) ? section : DEFAULT_MESSAGES_SECTION;
  const { data: inbox } = useGetNivInboxQuery(INBOX_QUERY_ARGS, { skip: !isAuthorized });
  const unread = inbox?.unreadCount || 0;

  return (
    <div className="nmsg">
      <div className="nmsg-head">
        <span className="nmsg-head-icon">
          <ChatsCircle size={20} weight="fill" />
        </span>
        <div className="nmsg-head-titles">
          <span className="nmsg-eyebrow">וואטסאפ ראשי · SMS גיבוי</span>
          <h3 className="nmsg-title">הודעות</h3>
        </div>
      </div>

      <nav className="nmsg-tabs" aria-label="הודעות">
        {MESSAGES_SECTIONS.map((s) => {
          const isActive = s.id === active;
          const badge = s.id === "inbox" ? unread : 0;
          return (
            <button
              key={s.id}
              type="button"
              className={`nmsg-tab ${isActive ? "active" : ""}`}
              onClick={() => onSectionChange(s.id)}
              aria-current={isActive ? "page" : undefined}
            >
              <s.icon size={15} weight={isActive ? "fill" : "regular"} />
              <span className="nmsg-tab-label">{s.label}</span>
              {badge > 0 && <span className="nmsg-tab-badge">{badge}</span>}
            </button>
          );
        })}
      </nav>

      <div className="nmsg-body" key={active}>
        {active === "policy" && <PolicyPanel isAuthorized={isAuthorized} />}
        {active === "inbox" && <InboxPanel isAuthorized={isAuthorized} />}
        {active === "outbox" && <OutboxPanel isAuthorized={isAuthorized} />}
        {active === "templates" && <TemplatesPanel isAuthorized={isAuthorized} />}
        {active === "usage" && <UsagePanel isAuthorized={isAuthorized} />}
      </div>
    </div>
  );
}

export default NivMessagesTab;
